import { Component, OnInit, Input } from '@angular/core';
import { AngularFireDatabase } from 'angularfire2/database';
import { NgProgress } from 'ngx-progressbar';
import { LogisticsService } from 'app/logistics-operations/shared/logistics.service';

@Component({
  selector: 'app-section1-1',
  templateUrl: './section1-1.component.html',
  styleUrls: ['./section1-1.component.css'],
  providers : [LogisticsService]
})
export class Section11Component implements OnInit {
  @Input("role") role;
  shipments:any;
  totalShipmentsPerDay:number = 0;
  totalCashCollectedPerDay:number = 0;
  totalIntransitPerDay:number = 0;
  totalPendingPerDay:number = 0;
  totalCompletedPerDay:number = 0;
  totalDeclinedPerDay:number = 0;
  currency:any;
  constructor(private db:AngularFireDatabase, private ngProgress: NgProgress, private service:LogisticsService, private ls:LogisticsService) { }

  ngOnInit() {
    //console.log("role",this.role);
    if(this.role == 'super admin')
    {
      this.shipments = this.db.list("shipments");
    }
    else
    {
      this.shipments = this.db.list("shipments", ref=> ref.orderByChild("branch").equalTo(localStorage.getItem("branch")));
    }
    this.getTotalShipmentsPerDay();
    this.getCurrency();
  }
  getCurrency()
  {
    this.ls.currency.subscribe(currency => {
      this.currency = currency; 
    });
  }
  getTotalShipmentsPerDay()
  {
    var date = new Date();
    var today = date.getDate()+"/"+(date.getMonth() + 1)+"/"+date.getFullYear();
    this.shipments.snapshotChanges().subscribe(item=>{
      this.ngProgress.start();
      this.totalShipmentsPerDay = 0;
      this.totalCashCollectedPerDay = 0;
      this.totalPendingPerDay= 0;
      this.totalIntransitPerDay= 0;
      this.totalCompletedPerDay= 0;
      this.totalDeclinedPerDay= 0;
        item.forEach(element =>{
            var shipment_date1 = element.payload.child("source").child("date").child("day").val()+"/"+element.payload.child("source").child("date").child("month").val()+"/"+element.payload.child("source").child("date").child("year").val();
            var shipment_date2 = element.payload.child("destination").child("date").child("day").val()+"/"+element.payload.child("destination").child("date").child("month").val()+"/"+element.payload.child("destination").child("date").child("year").val();
            if(today == shipment_date1 || today == shipment_date2)
            {
              this.totalShipmentsPerDay = this.totalShipmentsPerDay + 1;
              if(element.payload.child("cashCollected") != null)
              {
                this.totalCashCollectedPerDay = this.totalCashCollectedPerDay + element.payload.child("cashCollected").val();
              }
              switch (element.payload.child("status").val()) {
                case 2:
                  this.totalDeclinedPerDay = this.totalDeclinedPerDay +1;
                  break;
                case 6:
                  this.totalPendingPerDay = this.totalPendingPerDay +1;
                  break;
                case 7:
                  this.totalPendingPerDay = this.totalPendingPerDay +1;
                  break;
                case 8:
                  this.totalIntransitPerDay = this.totalIntransitPerDay +1;
                  break;
                case 9:
                  this.totalCompletedPerDay = this.totalCompletedPerDay +1;
                  break;
                case 10:
                  this.totalDeclinedPerDay = this.totalDeclinedPerDay +1;
                  break;
                case 11:
                  this.totalIntransitPerDay = this.totalIntransitPerDay +1;
                  break;
              }
            }
        });
        this.ngProgress.done();
      });
  }
}



// WEBPACK FOOTER //
// E:/Office Projects/Paarsel/paarsel_business_web/paarsel_business_web/src/app/logistics-operations/dashboard-main/section1-1/section1-1.component.ts